<template>
    <Modal class="edit-program-modal" :is_show="is_show_edit_modal" @click-bg="close"
        :class="{ 'is-loading': $store.state.is_loading }">
        <header class="edit-header">
            <h2>{{ is_edit ? 'Update' : 'Create'}} Your Application</h2>
            <i @click="close"><svg-icon name="close" /></i>
        </header>

        <Scrollbar class="edit-scroll-list" :show_bar="true">
            <Form :schema="schema" @submit="submit" :values="values" v-slot="{ errors, success }" class="user-form-wrap"
                :class="{ 'is-error': is_error }" ref="form">
                <div class="name-box">
                    <label class="label">
                        Application title <span class="req"> *</span>
                        <tippy :delay="[0, 20]" placement="right"  trigger="mouseenter click" 
                            :content="`This is how applicants for this program will be categorized in the Anchor portal. Members outside of your organization may see this in the metadata for your application's web page and via search engines or social shares.`">
                            <svg-icon name="question-3" />
                        </tippy>
                    </label>
                    <Field type="text" k="application_title" :placeholder="`${brand_name} program`" :had_value="values.application_title"
                        :error_msg="errors.application_title" :is_success="success.application_title" @update="update"
                        :ref="(el) => { els.push(el) }" />
                </div>

                <div :class="['name-box', error_call_back.application_url.val && 'name-box-err']">
                    <label class="label">Application URL:<span class="req"> *</span></label>
                    <div class="input">
                        <label>{{ label_text }}</label>
                        <input type="text" :placeholder="`${brand_name} program`" v-model="values.application_url" :disabled=" application_status !=='draft'">
                        <!-- values.application_url在子曾更動會需要刷新元件(因為title的更新會連動他)，但會導致需要點擊兩下才能焦點在該input身上，所以值些用input解決 -->
                        <!-- <Field type="text" k="application_url" :placeholder="`${brand_name} program`" :had_value="values.application_url"
                            :error_msg="errors.application_url" :is_success="success.application_url" @update="update"
                            :ref="(el) => { els.push(el) }" :key="key_ref"/> -->
                        <div class="err-client-msg-box" v-if="error_call_back.application_url.val">
                            <p class="err-msg" v-html="error_call_back.application_url.mes"></p>
                            <i><svg-icon name="alert" class="icon-left" /></i>
                        </div>
                    </div>

                </div>

                <div :class="['name-box', error_call_back.application_tag.val && 'name-box-err']">
                    <label class="label">Application tag<span class="req"> *</span>
                        <tippy :delay="[0, 20]" placement="right"  trigger="mouseenter click" 
                            :content="`Applicants approved to activate ${brand_name} storefronts will be automatically labeled with this tag, viewable in the Creator Management dashboard.`">
                            <svg-icon name="question-3" />
                        </tippy>
                    </label>
                
                    <Field type="text" k="create_tag" :placeholder="`${brand_name} program`" :had_value="values.create_tag"
                        :error_msg="errors.create_tag" :is_success="success.create_tag" @update="update"
                        :ref="(el) => { els.push(el) }" />
                    <div class="err-client-msg-box err-client-msg-box-2" v-if="error_call_back.application_tag.val">
                        <p class="err-msg" v-html="error_call_back.application_tag.mes"></p>
                        <i><svg-icon name="alert" class="icon-left" /></i>
                    </div>
                </div>

                <div class="name-box" v-if="need_des">
                    <label class="label">Meta description
                        <tippy :delay="[0, 20]" placement="right"  trigger="mouseenter click" 
                            :content="`The description entered will be viewable when people find your application via search engines and may even help it appear as a higher ranking. It may also appear in the link preview on social shares.`">
                            <svg-icon name="question-3" />
                        </tippy>
                    </label>
                    
                    <Field type="textarea" k="meta_description" :placeholder="`Apply to be a part of ${brand_name}'s ${values.application_title} and unlock exclusive perks.`" :had_value="values.meta_description"
                        :error_msg="errors.meta_description" :is_success="success.meta_description" @update="update"
                        :ref="(el) => { els.push(el) }" />
                </div>

                <br>
                <div class="btn-wrap">
                    <Button type="button" :style="'border'" size="32" :border_r="6" @click.native="close()">Cancel</Button>
                    <Button type="submit" color="dark-blue" size="32" :border_r="6">{{ need_des? 'Save':'Create' }}</Button>
                </div>
            </Form>
        </Scrollbar>
    </Modal>

</template>

<script>
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';

import * as yup from 'yup';
import { Tippy } from 'vue-tippy';

export default {
    name: 'edit-creator',
    emits: ['save'],

    components: {
        Field,
        Button,
        Form,
        Modal,
        Tippy,
        Scrollbar,
    },

    props:{
        need_des: {
            type: Boolean,
            default: false
        },
        is_edit: {
            type: Boolean,
            default: false
        },
        ambassador_application_id: {
            type: Number,
            default: 0
        },
        application_status:{
            type: String,
            default: 'draft'
        }
    },

    data() {
        return {
            is_show_edit_modal: false,
            is_show_alert_modal: false,
            is_can_delete: false,
            is_error: false,
            edit_tiktok_handle: false,
            edit_instagram_handle: false,
            error_msg: '',
            error_call_back:{
                application_url:{
                    mes:'This URL already exists.',
                    val:false,
                },
                application_tag:{
                    mes:'This creator tag already exists.',
                    val:false,
                },
            },

            els: [],

            values: {
                application_title: '',
                application_url: '',
                create_tag: '',
                meta_description:''
            },

            schema: yup.object().shape({
                application_title: yup.string().required('The application title can’t be left blank'),
                application_url: yup.string().required('The application URL can’t be left blank'),
                create_tag: yup.string()
                    .max(80, 'The character limit has been reached.')
                    .matches(
                        /^[a-zA-Z0-9.\-\s]+$/,
                        `Creator tags must not contain special characters except ".", "-", and spaces.`
                    ).matches(
                        /^(?!\s*$).+/,
                        `Creator tags must contain at least one non-space character.`
                    )
                    .required('The tag can’t be left blank'),
                meta_description: yup.string(),
            }),

            key_ref:0,

        }
    },

    computed: {
        brand_name(){
            return this.$store.state.user_data.merchant_account.merchant_display_name;
        },
        label_text(){
            let url=this.$store.state.user_data?this.$store.state.user_data.merchant_account.anchor_ambassador_subdomain:`${this.brand_name}.anchor.store`
            return `${url}/p/`
        },
    },

    methods: {

        update(obj) {
            this.is_error = false;
            this.error_msg = '';
            Object.keys(this.values).forEach(key => {
                if (key === obj.key) this.values[key] = obj.val;
            });

            if(obj.key==='application_title'){
                const cleanString = str => {
                    let result = str.replace(/[^a-zA-Z0-9\s-]/g, '');
                    result = result.replace(/\s+/g, '-');
                    return result;
                };
                this.values.application_url= cleanString(obj.val);;
            }

            if(obj.key==='application_url'){
                this.error_call_back[obj.key].val=false;
            }
            if(obj.key==='create_tag'){
                this.error_call_back['application_tag'].val=false;
                if(obj.val){
                    this.$refs.form.validate('create_tag');
                }    
            }

        },

        submit() {
            console.log('stop')
            this.is_error = false;
            this.$store.state.is_loading = true;
            let type= this.need_des?'edit':'create';
            let vi=this;
            let api_url = `/ambassador/check-application-url-tag?application_url=${this.values.application_url}&application_tag=${this.values.create_tag}`;

            if (this.ambassador_application_id) {
                api_url += `&ambassador_application_id=${this.ambassador_application_id}`;
            }
            
            this.$ajax(api_url, {
                method: 'get',
            }).then(res => {
                let n1 = 'application_tag';
                let n2 = 'application_url'
                const checkErrMes=(name)=>{
                    if(!res.data.data[name]){
                        vi.error_call_back[name].val=true;
                    }else{
                        vi.error_call_back[name].val=false;
                    }
                }
                checkErrMes(n1);
                checkErrMes(n2);

                if(!vi.error_call_back[n1].val && !vi.error_call_back[n2].val){
                    vi.$emit('save',{type:type, val: vi.values});
                    vi.close();
                }
                vi.$store.state.is_loading = false;
            }).catch(err=>{
                console.log(err)
                if(err.response && err.response.data &&err.response.data.message){
                    this.$notify(`<svg class="err-notify"><use xlink:href="#alert--sprite"></use></svg> ${err.response.data.message}!`);
                }
                else if(err.response && err.response.data && err.response.data.data &&err.response.data.data.message){
                    this.$notify(`<svg> class="err-notify"<use xlink:href="#alert--sprite"></use></svg> ${err.response.data.data.message}!`);
                }
                this.$store.state.is_loading=false;
            });  

        },

        async open(val) {
            this.els = [];
            this.is_error = false;
            this.error_msg = '';
            this.is_show_edit_modal = true;
            if(val){
                this.values.application_title=val[0].input_value;
                this.values.application_url= val[1].input_value;
                this.values.create_tag= val[2].input_value;
                this.values.meta_description= val[3].input_value;
            }else{
                this.values.application_title='';
                this.values.application_url= '';
                this.values.create_tag= '';
                this.values.meta_description= '';
            } 
        },

        close() {
            this.is_show_edit_modal = false;
            this.is_error = false;
            this.error_msg = '';
        },

    },

}
</script>
<style lang="scss">
.edit-program-modal {
    .ui-modal--container {
        background-color: var(--bg-02);
        width: 620px;
        padding: 16px;
    }

    .edit-header {
        display: flex;
        align-items: center;

        h2 {
            font: var(--font-demi-20);
            color: var(--black-90);
            flex: 1;
            line-height: 1;
        }

        i {
            height: 12px;
            width: 12px;
            position: relative;
            display: block;
            cursor: pointer;

            svg {
                height: 12px;
                width: 12px;
                fill: var(--black-50);
            }
        }
    }

    .user-form-wrap {
        margin-top: 16px;

        .name-box {
            position: relative;
        }

        .label {
            font: var(--font-fg-16);
            color: var(--black-90);
            display: flex;
            align-items: center;

            span{
                cursor: pointer;
            }

            .svg-icon{
                width: 12px;
                height: 12px;
                fill:var(--neutral);
            }

            .req {
                color: var(--alert);
            }
        }

        input {
            width: 100%;
            padding: 6px 8px;
            font-size: 14px;
            color: var(--black-90);
            outline: none;
            height: 36px;
            border: 1px solid var(--black-20);
            border-radius: 6px;

            &:focus {
                border: 1px solid var(--dark-blue);
            }
        }


        .input {
            position: relative;
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            flex: 1;

            label {
                height: 36px;
                background: #CBD4E1;
                padding: 0 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                color: var(--black-90);
                border-radius: 6px 0px 0px 6px;
            }
            
            input {
                border-radius: 0 6px 6px 0;
                font-family: var(--font);
                flex:1;
                margin: 12px 0;

                &::placeholder {
                    color: var(--black-50);
                    font-weight: 500;
                }

                &:disabled{
                    cursor: not-allowed;
                }
            }
            .ui-input{
                flex:1;
            }
        }

        .desc {
            font-size: 14px;
            color: var(--black-75);
        }

        .ui-input {
            margin: 12px 0;
            position: relative;
        }

        .err-msg-box{
            position: absolute;
            right: 0;
        }

        .btn-wrap {
            display: flex;
            justify-content: flex-end;

            .ui-button {
                width: 110px;
                padding: unset;

                &:first-child{
                    margin-right: 16px;
                }
            }
        }

        &.is-error {

            .ui-input .ui-input--wrap select,
            .ui-input .ui-input--wrap input,
            .ui-input .ui-input--select select,
            .ui-input .ui-input--select input,
            .ui-input .ui-input--icon-wrap {
                border-color: var(--alert) !important;
            }

            .error-msg {
                margin: 4px 0 0;
                font-size: 12px;
                color: var(--alert);

                &::before {
                    content: '*';
                }
            }
        }

        .coll-chec {
            .ui-checkbox {
                margin-top: 8px;
            }
        }

        .name-box-err{
            .the-input input{
                border: 1px solid var(--alert);
            }
        }

        .err-client-msg-box{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color:var(--alert);
            position: absolute;
            bottom: -10px;
            right: 0;
            font-size: 12px;

            &.err-client-msg-box-2{
                bottom: -20px;
            }

            i{
                width: 14px;
                height: 14px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 5px;
            }

            svg{
                width: 10.5px;
                height: 10.5px;
                fill:var(--alert);
            }
        }
    }

    &.is-loading {
        .user-form-wrap {
            opacity: .5;
            pointer-events: none;
        }
    }


}
</style>
